<template>
  <div>
    <modal name="ver-documento-info" :width="800" :height="600" :clickToClose="false" :class="{'front-modal': isFrontModal}">
      <div class="modal-content modalContent">
        <span class="closebtn" @click="closeModal">&times;</span>
      </div>
      <div v-if="isImage">
        <img :src="documento" alt="Document Image" class="img-fluid p-3" />
      </div>
      <iframe v-else :src="documento" frameborder="0" class="iframe-content p-3"></iframe>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'App',
  props: {
    documento: String,
    isFrontModal: {
      type: Boolean,
      default: false
    },
    isImage: Boolean
  },
  methods: {
    closeModal() {
      this.$modal.hide('ver-documento-info');
      this.$modal.show('info-operacion');
    },
  }
};
</script>
  
  <style>
  .btn-blue {
    border-radius: 10px;
    background-image: linear-gradient(to right, #085da8, #003c71);
    border: #ffffff;
    color: white;
  }
  
  .vm--modal {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 30px !important;
  }
  
  .front-modal {
    z-index: 1050; /* Adjust to a higher value if needed */
  }
  
  .modalContent {
    padding: 15px;
    background-color: white;
    color: white;
    border-radius: 15px;
    position: relative;
    text-align: center;
    border-color: white;
  }
  
  .closebtn {
    position: absolute;
    top: 10px;
    right: 15px;
    color: #003c71;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .closebtn:hover {
    color: #003c718c;
  }
  
  .iframe-content {
    width: 100%;
    height: calc(100% - 50px);
    border-color: white;
    border-radius: 0 0 15px 15px;
  }
  
  .modal-header {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 15px;
    color: #003c71;
  }
  
  .modal-body {
    padding: 20px;
  }
  </style>
  